import { useQuery, useQueryClient, useMutation } from "react-query";
import { api } from "utils/api";

const getRaffleIsEntered = (raffleId?: string): Promise<{ entered: boolean }> =>
  raffleId !== undefined
    ? api(`/profile/raffle/${raffleId}`)
    : Promise.reject(new Error("Invalid raffle id"));

const enterRaffle = (raffleId?: string): Promise<{ status: string }> =>
  raffleId !== undefined
    ? api(`/profile/raffle/${raffleId}`, {
        method: "POST",
        body: JSON.stringify({}),
      })
    : Promise.reject(new Error("Invalid raffle id"));

const useClaimRaffle = (raffleId?: string) => {
  const queryClient = useQueryClient();

  const query = useQuery(
    ["raffleItems", raffleId],
    () => getRaffleIsEntered(raffleId),
    {
      enabled: !!raffleId,
    }
  );

  const isEntered = query.isSuccess && query.data.entered;

  const mutation = useMutation(() => enterRaffle(raffleId), {
    onSuccess: () => {
      queryClient.setQueryData(["raffleItems", raffleId], { entered: true });
    },
  });

  return { query, isEntered, mutation };
};

export { useClaimRaffle };
